// @ts-nocheck
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

interface OrderDetailsSubTitle {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
}

export const orderDetailsSubTitle: OrderDetailsSubTitle = {
    wrapper: {
        css: css`
            padding-bottom: ${pxToRem(10)};
        `,
    },
    titleText: {
        as: "h3",
        color: "primary",
        css: css`
            margin-bottom: 0.5em;
            ${({ theme }) => `
                font-size: ${theme.design.typography.size.base};
                font-weight: ${theme.design.typography.weight.bold};
            `}

            @media print {
                font-size: ${pxToRem(16)};
            }
        `,
    },
};
